import { accountingsActions as accountings } from 'src/store/accountings/accountings.actions';

const initialState = {
  accountings: {
    isFetching: false,
    tempAccountings: {},
    postedAccountings: {},
    error: false,
    errorcodes: [],
  },
  slaughtersList: {
    isFetching: false, // kept for backwards compatibility, prefer using one of the two isFetching- below as this one is set to false when either one returns
    isFetchingPosted: false,
    isFetchingTemp: false,

    // null indicates result not yet determined, empty array incidates not results
    postedSlaughters: null,
    tempSlaughters: null,
    error: false,
    errorcodes: [],
  },
  documents: {
    isFetching: false,
    data: null,
    error: false,
  },
  farmerStatistics: {
    isFetching: false,
    isFetchingAll: false,
    data: null,
    error: false,
    fetchedAll: false,
  },
  slaughterhouseStatistics: {
    isFetching: false,
    data: null,
    error: false,
  },
  dashboardStatistics: {
    isFetching: false,
    data: null,
    error: false,
  },
  animalKindsWithStats: {
    isFetching: false,
    data: null,
    error: false,
  },
};

const accountingsReducer = (state = initialState, action) => {
  switch (action.type) {
  case 'RESET_STORE':
    return initialState;
  case accountings.fetchPostedByDate().type:
    return {
      ...state,
      accountings: {
        ...state.accountings,
        postedAccountings: {
          ...state.accountings.postedAccountings,
          [`${action.payload.date}/${action.payload.settlement_no}`]: null,
        },

        isFetching: true,
        error: false,
      },
    };
  case accountings.fetchPostedByDateSuccess().type:
    return {
      ...state,
      accountings: {
        ...state.accountings,
        postedAccountings: {
          ...state.accountings.postedAccountings,
          [`${action.payload.date}/${action.payload.settlement_no}`]: { ...action.payload.slaughter_data },
        },
        isFetching: false,
        error: false,
      },
    };
  case accountings.fetchPostedbyDateFailure().type:
    return {
      ...state,
      accountings: {
        ...state.accountings,
        postedAccountings: {
          ...state.accountings.postedAccountings,
          [`${action.payload.date}/${action.payload.settlement_no}`]: null,
        },
        isFetching: false,
        error: true,
        errorcodes: action.payload.errorcodes,
      },
    };
  case accountings.fetchTempByDate().type:
    return {
      ...state,
      accountings: {
        ...state.accountings,
        tempAccountings: {
          ...state.accountings.tempAccountings,
          [`${action.payload.date}`]: null,
        },

        isFetching: true,
        error: false,
      },
    };
  case accountings.fetchTempByDateSuccess().type:
    return {
      ...state,
      accountings: {
        ...state.accountings,
        tempAccountings: {
          ...state.accountings.tempAccountings,
          [`${action.payload.date}`]: { ...action.payload.slaughter_data },
        },
        isFetching: false,
        error: false,
      },
    };
  case accountings.fetchTempbyDateFailure().type:
    return {
      ...state,
      accountings: {
        ...state.accountings,
        tempAccountings: {
          ...state.accountings.tempAccountings,
          [`${action.payload.date}`]: null,
        },
        isFetching: false,
        error: true,
        errorcodes: action.payload.errorcodes,
      },
    };

  case accountings.fetchPostedSlaughterList().type:
    return {
      ...state,
      slaughtersList: {
        ...state.slaughtersList,
        postedSlaughters: null,
        isFetching: true,
        isFetchingPosted: true,
        error: false,
      },
    };
  case accountings.fetchPostedSlaughterListSuccess().type:
    return {
      ...state,
      slaughtersList: {
        ...state.slaughtersList,
        postedSlaughters: action.payload.list,
        isFetching: false,
        isFetchingPosted: false,
        error: false,
      },
    };
  case accountings.fetchPostedSlaughterListFailure().type:
    return {
      ...state,
      slaughtersList: {
        ...state.slaughtersList,
        postedSlaughters: null,
        isFetching: false,
        isFetchingPosted: false,
        error: true,
        errorcodes: action.payload.errorcodes,
      },
    };

  case accountings.fetchTempSlaughterList().type:
    return {
      ...state,
      slaughtersList: {
        ...state.slaughtersList,
        tempSlaughters: null,
        isFetching: true,
        isFetchingTemp: true,
        error: false,
      },
    };
  case accountings.fetchTempSlaughterListSuccess().type:
    return {
      ...state,
      slaughtersList: {
        ...state.slaughtersList,
        tempSlaughters: action.payload.list,
        isFetching: false,
        isFetchingTemp: false,
        error: false,
      },
    };
  case accountings.fetchTempSlaughterListFailure().type:
    return {
      ...state,
      slaughtersList: {
        ...state.slaughtersList,
        tempSlaughters: null,
        isFetching: false,
        isFetchingTemp: false,
        error: true,
        errorcodes: action.payload.errorcodes,
      },
    };
  case accountings.fetchDocuments().type:
    return {
      ...state,
      documents: {
        ...state.documents,
        data: null,
        isFetching: true,
        error: false,
      },
    };
  case accountings.fetchDocumentsSuccess().type:
    return {
      ...state,
      documents: {
        ...state.documents,
        data: action.payload.documents,
        isFetching: false,
        error: false,
      },
    };
  case accountings.fetchDocumentsFailure().type:
    return {
      ...state,
      documents: {
        ...state.documents,
        data: null,
        isFetching: false,
        error: true,
      },
    };

  case accountings.fetchFarmerStatistics().type:
    const kind = action.payload.kind;
    const timeFrame = action.payload.timeFrame;
    const subkind = action.payload.subkind;
    const newStateFetchFarmerStatistics = {
      ...state,
      farmerStatistics: {
        ...state.farmerStatistics,
        data: {
          ...state.farmerStatistics.data,
          [timeFrame]: {
            ...(state.farmerStatistics?.data?.[timeFrame] || {}),
            [kind]: {
              ...(state.farmerStatistics?.data?.[timeFrame]?.[kind] || {}),
              subkinds: {
                ...(state.farmerStatistics?.data?.[timeFrame]?.[kind]
                  ?.subkinds || {}),
                [subkind]: {
                  ...(state.farmerStatistics?.data?.[timeFrame]?.[kind]
                    ?.subkinds[subkind] || {}),
                  isFetching: true,
                },
              },
            },
          },
        },
        isFetching: true,
        error: false,
      },
    };
    return newStateFetchFarmerStatistics;
  case accountings.fetchFarmerStatisticsSuccess().type:
    const kindSuccess = action.payload.kind;
    const timeFrameSuccess = action.payload.timeFrame;
    const subkindSuccess = action.payload.subkind;
    const newStateFetchFarmerStatiticsSuccess = {
      ...state,
      farmerStatistics: {
        ...state.farmerStatistics,
        data: {
          ...state.farmerStatistics.data,
          [timeFrameSuccess]: {
            ...(state.farmerStatistics?.data?.[timeFrameSuccess] || {}),
            [kindSuccess]: {
              ...(state.farmerStatistics?.data?.[timeFrameSuccess]?.[
                kindSuccess
              ] || {}),
              subkinds: {
                ...(state.farmerStatistics?.data?.[timeFrameSuccess]?.[
                  kindSuccess
                ]?.subkinds || {}),
                [subkindSuccess]: {
                  ...action.payload.statistics.farmer_statistics[
                    timeFrameSuccess
                  ][kindSuccess].subkinds[subkindSuccess],
                  isFetching: false,
                },
              },
            },
          },
        },
        isFetching: false,
        error: false,
      },
    };
    return newStateFetchFarmerStatiticsSuccess;
  case accountings.fetchFarmerStatisticsFailure().type:
    return {
      ...state,
      farmerStatistics: {
        ...state.farmerStatistics,
        data: null,
        isFetching: false,
        error: true,
      },
    };
  case accountings.fetchAllFarmerStatistics().type:
    return {
      ...state,
      farmerStatistics: {
        ...state.farmerStatistics,
        isFetchingAll: true,
        fetchedAll: false,
      },
    };
  case accountings.fetchAllFarmerStatisticsSuccess().type:
    return {
      ...state,
      farmerStatistics: {
        ...state.farmerStatistics,
        data: action.payload.data,
        isFetching: false,
        isFetchingAll: false,
        error: false,
        fetchedAll: true,
      },
    };

  case accountings.fetchSlaughterhouseStatistics().type:
    return {
      ...state,
      slaughterhouseStatistics: {
        ...state.slaughterhouseStatistics,
        data: null,
        isFetching: true,
        error: false,
      },
    };
  case accountings.fetchSlaughterhouseStatisticsSuccess().type:
    return {
      ...state,
      slaughterhouseStatistics: {
        ...state.slaughterhouseStatistics,
        data: action.payload.statistics.slaughterhouse_statistics,
        isFetching: false,
        error: false,
      },
    };
  case accountings.fetchSlaughterhouseStatisticsFailure().type:
    return {
      ...state,
      slaughterhouseStatistics: {
        ...state.slaughterhouseStatistics,
        data: null,
        isFetching: false,
        error: true,
      },
    };

  case accountings.fetchDashboardStatistics().type:
    return {
      ...state,
      dashboardStatistics: {
        ...state.dashboardStatistics,
        data: null,
        isFetching: true,
        error: false,
      },
    };
  case accountings.fetchDashboardStatisticsSuccess().type:
    return {
      ...state,
      dashboardStatistics: {
        ...state.dashboardStatistics,
        data: action.payload.statistics.statistics,
        isFetching: action.payload.isFetching,
        error: false,
      },
    };
  case accountings.fetchDashboardStatisticsFailure().type:
    return {
      ...state,
      dashboardStatistics: {
        ...state.dashboardStatistics,
        data: null,
        isFetching: false,
        error: true,
      },
    };
  case accountings.fetchAnimalKindsWithStats().type:
    return {
      ...state,
      animalKindsWithStats: {
        ...state.animalKindsWithStats,
        data: null,
        isFetching: true,
        error: false,
      },
    };
  case accountings.fetchAnimalKindsWithStatsSuccess().type:
    return {
      ...state,
      animalKindsWithStats: {
        ...state.animalKindsWithStats,
        data: action.payload.animalKindsWithStats,
        isFetching: false,
        error: false,
      },
    };
  case accountings.fetchAnimalKindsWithStatsFailure().type:
    return {
      ...state,
      animalKindsWithStats: {
        ...state.animalKindsWithStats,
        data: null,
        isFetching: false,
        error: true,
      },
    };
  default:
    return state;
  }
};

export default accountingsReducer;
